// extracted by mini-css-extract-plugin
module.exports = {"sliderValueBox":"style_sliderValueBox__1-9YL"};